import { AbstractControl, ValidatorFn } from '@angular/forms';
import Validator from 'validator';

export const email = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null =>
      Validator.isEmail(control?.value)
    ? null : { invalidEmail: control.value };
};
